import { combineReducers } from 'redux'
import { reducers } from './features'

export default combineReducers(reducers)
